(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["keks-banner"] && !Shopify.designMode) return;
  try {
    
  /*
    Wechsel-Banner: zwei oder drei Folien, wechselt alle `data-sekunden` von selbst.
    Hält an, solange Maus oder Fokus darauf liegen oder der Tab verdeckt ist. Nach Wischen oder
    Punkt-Klick bleibt es stehen. Bei „Bewegung reduzieren“ kein Selbstwechsel.
  */
  if (!customElements.get('keks-wechsel')) {
    class KeksWechsel extends HTMLElement {
      connectedCallback() {
        this.spur = this.querySelector('.keks-wechsel__spur');
        this.folien = [...this.querySelectorAll('.keks-wechsel__folie')];
        this.punkte = [...this.querySelectorAll('.keks-wechsel__punkt')];
        this.aktiv = 0;
        this.angehalten = false;
        this.gestoppt = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.zeige(0);

        this.punkte.forEach((punkt) =>
          punkt.addEventListener('click', () => {
            this.stopp();
            this.zeige(Number(punkt.dataset.folie));
          })
        );

        let startX = null;
        let startY = null;
        this.addEventListener('pointerdown', (e) => {
          startX = e.clientX;
          startY = e.clientY;
        });
        this.addEventListener('pointerup', (e) => {
          if (startX === null) return;
          const dx = e.clientX - startX;
          const dy = e.clientY - startY;
          startX = null;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          this.wischte = true;
          this.stopp();
          this.zeige(dx < 0 ? Math.min(this.aktiv + 1, this.folien.length - 1) : Math.max(this.aktiv - 1, 0));
        });
        // Nach einem Wischen keinen Link auslösen
        this.addEventListener(
          'click',
          (e) => {
            if (this.wischte) {
              e.preventDefault();
              e.stopPropagation();
              this.wischte = false;
            }
          },
          true
        );

        const halt = () => (this.angehalten = true);
        const weiter = () => (this.angehalten = false);
        this.addEventListener('mouseenter', halt);
        this.addEventListener('mouseleave', weiter);
        this.addEventListener('focusin', halt);
        this.addEventListener('focusout', weiter);

        const sekunden = Math.max(3, Number(this.dataset.sekunden) || 6);
        this.uhr = setInterval(() => {
          if (this.gestoppt || this.angehalten || document.hidden) return;
          this.zeige((this.aktiv + 1) % this.folien.length);
        }, sekunden * 1000);
      }

      disconnectedCallback() {
        clearInterval(this.uhr);
      }

      stopp() {
        this.gestoppt = true;
      }

      zeige(index) {
        this.aktiv = index;
        this.spur.style.transform = `translateX(${index * -100}%)`;
        this.folien.forEach((folie, i) => {
          const an = i === index;
          folie.toggleAttribute('inert', !an);
          folie.setAttribute('aria-hidden', String(!an));
        });
        this.punkte.forEach((punkt, i) => punkt.setAttribute('aria-current', String(i === index)));
      }
    }
    customElements.define('keks-wechsel', KeksWechsel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keks-kacheln"] && !Shopify.designMode) return;
  try {
    
  /* Suche nur in dieser Kategorie: die Liste der Motive kommt einmal beim ersten Antippen, gesucht wird im Browser. */
  if (!customElements.get('keks-weltsuche')) {
    const klein = (text) =>
      String(text || '')
        .toLowerCase()
        .replace(/ß/g, 'ss')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/ae/g, 'a')
        .replace(/oe/g, 'o')
        .replace(/ue/g, 'u')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();

    const neu = (tag, klasse, text) => {
      const el = document.createElement(tag);
      if (klasse) el.className = klasse;
      if (text != null) el.textContent = text;
      return el;
    };

    class KeksWeltsuche extends HTMLElement {
      connectedCallback() {
        this.feld = this.querySelector('input[type="search"]');
        this.ergebnis = this.querySelector('[data-ergebnis]');
        this.zahl = 48;
        if (!this.dataset.quelle || !this.feld) return;
        this.feld.addEventListener('focus', () => this.laden(), { once: true });
        this.feld.addEventListener('input', () => {
          clearTimeout(this.takt);
          this.takt = setTimeout(() => this.suchen(), 120);
        });
        this.querySelector('form').addEventListener('submit', (e) => {
          if (klein(this.feld.value).length < 2) return;
          e.preventDefault();
          this.suchen();
        });
      }

      laden() {
        if (!this.liste) {
          const seiten = Math.max(1, Number(this.dataset.seiten) || 1);
          const abrufe = [];
          for (let i = 1; i <= seiten; i++) {
            abrufe.push(fetch(`${this.dataset.quelle}&page=${i}`).then((r) => r.json()));
          }
          this.liste = Promise.all(abrufe).then((teile) =>
            teile.flatMap((t) => t.p || []).map(([name, url, bild, preis]) => ({ name, url, bild, preis, k: klein(name) }))
          );
        }
        return this.liste;
      }

      async suchen() {
        const frage = klein(this.feld.value);
        const an = frage.length >= 2;
        document.body.classList.toggle('keks-sucht', an);
        this.closest('.keks-welten')?.toggleAttribute('data-sucht', an);
        if (!an) {
          this.ergebnis.hidden = true;
          this.ergebnis.replaceChildren();
          return;
        }
        let liste;
        try {
          liste = await this.laden();
        } catch (e) {
          this.liste = null;
          return;
        }
        if (klein(this.feld.value) !== frage) return;
        const woerter = frage.split(' ');
        const treffer = [];
        const gesehen = new Set();
        for (const p of liste) {
          if (!gesehen.has(p.url) && woerter.every((w) => p.k.includes(w))) {
            gesehen.add(p.url);
            treffer.push(p);
          }
        }
        const kacheln = [...(this.closest('.keks-welten')?.querySelectorAll('[data-kacheln] .keks-welt[data-titel] a') || [])]
          .filter((a) => woerter.every((w) => klein(a.closest('[data-titel]').dataset.titel).includes(w)));
        this.zeigen(frage, treffer, kacheln);
      }

      zeigen(frage, treffer, kacheln) {
        const d = this.dataset;
        const teile = [];
        if (kacheln.length) {
          const chips = neu('ul', 'keks-chips keks-weltsuche__chips');
          chips.setAttribute('role', 'list');
          for (const a of kacheln) {
            const li = neu('li');
            const link = neu('a', 'keks-chip', a.closest('[data-titel]').dataset.titel);
            link.href = a.getAttribute('href');
            li.append(link);
            chips.append(li);
          }
          teile.push(chips);
        }
        if (treffer.length) {
          teile.push(
            neu(
              'p',
              'keks-weltsuche__zeile',
              (treffer.length === 1 ? d.trefferEins : d.trefferText)
                .replace('{anzahl}', treffer.length)
                .replace('{kategorie}', d.kategorie)
            )
          );
          const raster = neu('ul', 'keks-weltsuche__raster');
          raster.setAttribute('role', 'list');
          for (const p of treffer.slice(0, this.zahl)) {
            const li = neu('li', 'keks-weltsuche__karte');
            const a = neu('a', 'keks-weltsuche__link');
            a.href = p.url;
            const bild = neu('span', 'keks-weltsuche__bild');
            if (p.bild) {
              const img = neu('img');
              img.src = p.bild;
              img.alt = '';
              img.loading = 'lazy';
              img.width = 360;
              img.height = 360;
              bild.append(img);
            }
            a.append(bild, neu('span', 'keks-weltsuche__name', p.name), neu('span', 'keks-weltsuche__preis', p.preis));
            li.append(a);
            raster.append(li);
          }
          teile.push(raster);
          if (treffer.length > this.zahl) {
            const mehr = neu('button', 'button button-secondary keks-weltsuche__mehr', d.mehrText);
            mehr.type = 'button';
            mehr.addEventListener('click', () => {
              this.zahl += 48;
              this.zeigen(frage, treffer, kacheln);
            });
            teile.push(mehr);
          }
        } else {
          teile.push(neu('p', 'keks-weltsuche__zeile', d.leerText.replace('{kategorie}', d.kategorie)));
        }
        const fuss = neu('p', 'keks-weltsuche__shop');
        const shop = neu('a', '', d.shopText);
        shop.href = `${d.suchseite}?q=${encodeURIComponent(this.feld.value.trim())}&options%5Bprefix%5D=last`;
        fuss.append(shop);
        teile.push(fuss);
        if (!treffer.length && d.angebotFett) {
          const angebot = neu('a', 'keks-weltsuche__angebot');
          angebot.href = d.angebotLink;
          const knopf = neu('span', 'button keks-button--creme keks-button--klein', d.angebotKnopf);
          angebot.append(neu('span', 'keks-welt__angebot-fett', d.angebotFett), knopf);
          teile.push(angebot);
        }
        this.ergebnis.replaceChildren(...teile);
        this.ergebnis.hidden = false;
      }
    }

    customElements.define('keks-weltsuche', KeksWeltsuche);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
